/**
 * Maps event region to the corresponding description key for partnering packages
 * @param region - The event region (europe, asia, usa, dach)
 * @returns The description key to use for the package content
 */
export const getDescriptionKeyByRegion = (region: string): string => {
  switch (region) {
    case 'europe':
    case 'asia':
      return 'en';
    case 'usa':
      return 'us';
    case 'dach':
      return 'de';
    default:
      return 'en'; // fallback to English
  }
}; 